import { useLocalSessionId } from '@daily-co/daily-react';
import { useEffect, useState } from 'react';

import { useSidebarView } from '/lib/state/core';

import { useHandRaising } from './useHandRaising';
import { usePreviousValue } from './usePreviousValue';

export const useHandRaisingBadgeStatus = () => {
  const localSessionId = useLocalSessionId();
  const [sidebarView] = useSidebarView();
  const { handRaisedParticipants } = useHandRaising();
  const previousHandRaisedParticipants = usePreviousValue(
    handRaisedParticipants
  );
  const lastHandRaiserId =
    handRaisedParticipants[handRaisedParticipants?.length - 1];

  const [handRaiseBadgeStatus, setHandRaiseBadgeStatus] = useState(false);

  useEffect(() => {
    // Show the badge when the queue's length has increased,
    // and when the hand raiser is not the local participant
    if (
      handRaisedParticipants?.length > previousHandRaisedParticipants?.length &&
      lastHandRaiserId !== localSessionId
    ) {
      setHandRaiseBadgeStatus(true);
    }

    // don't show the badge when the People panel is opened
    if (sidebarView === 'people') {
      setHandRaiseBadgeStatus(false);
    }

    // Immediately hide the badge when there are no hand raisers
    if (handRaisedParticipants.length === 0) {
      setHandRaiseBadgeStatus(false);
    }
  }, [
    handRaisedParticipants?.length,
    previousHandRaisedParticipants?.length,
    lastHandRaiserId,
    localSessionId,
    sidebarView,
  ]);

  return handRaiseBadgeStatus;
};
